/**
 * Helper functions for handling origin-based navigation and text
 */

import { getTerm } from './workkeysReplaceTerms'

const testTermLower = getTerm('test')

/**
 * Formats the origin parameter into a human-readable title
 * @param origin - The origin parameter from URL (e.g., "study-plan", "practice-tests")
 * @returns Formatted string (e.g., "Study Plan", "Practice Tests")
 */
export const formatOriginTitle = (origin: string | null): string => {
  if (!origin) return 'Study Plan' // Default fallback

  return origin
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/**
 * Gets the return button text based on origin
 * @param origin - The origin parameter from URL
 * @returns Button text (e.g., "Return to Dashboard")
 */
export const getReturnButtonText = (origin: string | null): string => {
  if (!origin) return 'Return to Study Plan'
  return `Return to ${formatOriginTitle(origin)}`
}

/**
 * Gets the return message text based on origin
 * @param origin - The origin parameter from URL
 * @returns Message text (e.g., "Go back to Dashboard to see your test score.")
 */
export const getReturnMessage = (origin: string | null): string => {
  if (!origin) return `Go back to your Study Plan to see your ${testTermLower} score.`
  return `Go back to ${formatOriginTitle(origin)} to see your ${testTermLower} score.`
}